export default __webpack_public_path__ + "static/media/flaticon.ed866b96.woff2";